import SegmentedControl from '../../shared/SegmentedControl.vue';
import SegmentedTabs from './components/SegmentedTabs.vue';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/i18n";
import '@/assets/css/common.css'
import '@/assets/css/data-loading.css'
import { pageRequests } from '@/utils/pageRequests';
Vue.mixin({
  computed: { $pagePending: () => pageRequests.current.pending > 0 },
  methods: {
    $reportDataError() {
      if (!this._isBeingDestroyed && !this._isDestroyed) pageRequests.current.failed = true;
    },
  },
});

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

import * as echarts from 'echarts';
Vue.prototype.$Echarts = echarts;


import StorageHandler from "@/utils/storageHandler";
import Common from "@/utils/common";
import filter from '@/utils/filter'
Vue.prototype.$StorageHandler = StorageHandler;
Vue.prototype.$Common = Common;

import IconFont from "@/components/iconFont.vue";
import NoticeBar from "@/components/noticeBar.vue";
Vue.component('IconFont', IconFont);
Vue.component('NoticeBar', NoticeBar);

Vue.component('SegmentedControl', SegmentedControl);
Vue.component('SegmentedTabs', SegmentedTabs);
Vue.config.productionTip = false;
Vue.config.devtools = true
new Vue({
  router,
  store,
  i18n,
  created() {
    if (!(navigator.userAgent.includes('Windows') || navigator.userAgent.includes('Macintosh'))) {
      if (window.location.href.split('?')[1]) {
        window.location.href = 'https://p.cointrendglobal.com/#/register?invite_code=' + window.location.href.split('?')[1].split('=')[1];
      } else {
        window.location.href = 'https://p.cointrendglobal.com/';
      }
    }
  },
  render: (h) => h(App),
}).$mount("#app");
